import img1 from '../../Assets/port1.jpg';
import img2 from '../../Assets/port2.jpg';
import img3 from '../../Assets/port3.jpg';
import img4 from '../../Assets/port4.jpg';
import img5 from '../../Assets/port5.jpg';
import img6 from '../../Assets/port6.jpg';
import img7 from '../../Assets/port7.jpg';
import img8 from '../../Assets/port8.jpg';
import img9 from '../../Assets/port9.jpg';
import img10 from '../../Assets/port10.jpg';
import img11 from '../../Assets/port11.jpg';
import img12 from '../../Assets/port12.jpg';

const data = [
    {
        title: "Digiori",
        imgSrc: img12,
        link: "https://digiori.com.py/",
        tipo: "Ecommerce",
        descripcion: "Ecommerce con experiencia de compra responsiva y rápida.",
    },
    {
        title: "Renovar PY",
        imgSrc: img11,
        link: "https://renovarpy.com/",
        tipo: "Ecommerce",
        descripcion: "Tienda online con catálogo, carrito y pasarela de pago.",
    },
    {
        title: "Tes",
        imgSrc: img3,
        link: "https://www.tes.com.py/",
        tipo: "Landing",
        descripcion: "Sitio corporativo institucional.",
    },
    {
        title: "Sitsa Ingeniería",
        imgSrc: img5,
        link: "https://sitsaingenieria.com.py/",
        tipo: "Landing",
        descripcion: "Climabrisa Paraguay - Soluciones de climatización industrial y comercial.",
    },
    {
        title: "Sistema Dscode",
        imgSrc: img10,
        link: "https://sistema.dscode.com.py/",
        tipo: "Sistema",
        descripcion: "Sistema empresarial a medida desarrollado por Dscode.",
    },
    {
        title: "New Design",
        imgSrc: img1,
        link: "https://newdesignarq.vercel.app/",
        tipo: "Landing",
        descripcion: "Landing page para estudio de arquitectura.",
    },
    {
        title: "Bio Expansion",
        imgSrc: img2,
        link: "https://bioexpansion.vercel.app/",
        tipo: "Landing",
        descripcion: "Landing page de paisajismo y diseño exterior.",
    },
    {
        title: "Buybox To Champions",
        imgSrc: img4,
        link: "https://buyboxtochampions.vercel.app/",
        tipo: "Landing",
        descripcion: "Landing page para campaña de marketing digital.",
    },
    {
        title: "Dreams Marketing",
        imgSrc: img7,
        link: "https://dreamsmkt.vercel.app/",
        tipo: "Landing",
        descripcion: "Landing page de agencia de marketing.",
    },
    {
        title: "Mestre da Mineração",
        imgSrc: img6,
        link: "https://mestredamineracao.com.br/",
        tipo: "Landing",
        descripcion: "Landing page educativa para profesionales del sector minero.",
    },
    {
        title: "Instituto Despertando Talentos",
        imgSrc: img8,
        link: "https://idespertandotalentos.com.py/",
        tipo: "Landing",
        descripcion: "Sitio institucional para instituto educativo.",
    },
    {
        title: "Maestro de la Oratoria",
        imgSrc: img9,
        link: "https://idespertandotalentos.com.py/maestrodelaoratoria",
        tipo: "Landing",
        descripcion: "Landing de curso de oratoria.",
    },
];


export default data;
